import { render, staticRenderFns } from "./TemplateMappingTable.vue?vue&type=template&id=396920d7&"
import script from "./TemplateMappingTable.vue?vue&type=script&lang=js&"
export * from "./TemplateMappingTable.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMappingTable.vue?vue&type=style&index=0&id=396920d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports